import {
  LIST_getInstance2vniy0f7mmb29 as LIST_getInstance,
  CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  drop3na99dw9feawf as drop,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  SerializableProperty3cbm268cpjr8q as SerializableProperty,
  get_serializableProperties1162nosnaangd as get_serializableProperties,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializableProperty.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  lines3g90sq0zeq43v as lines,
  isBlank1dvkhjjvox3p0 as isBlank,
  contains2el4s70rdq4ld as contains,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOf1jh22dvmctj1r as listOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { checkIndexOverflow3frtmheghr0th as checkIndexOverflow } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toMap1vec9topfei08 as toMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { default1jaun537xukbl as default_0 } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Defaults.mjs';
import {
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
  toShortOrNullaofc97cf0fby as toShortOrNull,
  toByteOrNull1d9df6kfxiznx as toByteOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import { toDoubleOrNullkxwozihadygj as toDoubleOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { listElement3jy3tr2z6og1q as listElement } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { toList383f556t1dixk as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { CodeBlockSemantic_getInstance2upnqm8klgt9a as CodeBlockSemantic_getInstance } from '../components/TempSemantics.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import {
  cellFormub3o1hqp20e5 as cellForm,
  labeledForm2ame2d0a5lql9 as labeledForm,
  labeledView3rpvir7z2o9ii as labeledView,
  Renderer1fhwti5gmwutm as Renderer,
} from './Renderer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerCsv(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, VOID, LIST_getInstance()), CsvRenderer_instance);
}
function toCsv($this, list, properties) {
  var sb = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  // Inline function 'kotlin.text.appendLine' call
  var value = joinToString(properties, ',', VOID, VOID, VOID, VOID, CsvRenderer$toCsv$lambda);
  // Inline function 'kotlin.text.appendLine' call
  sb.append_22ad7x_k$(value).append_58al37_k$(_Char___init__impl__6a9atx(10));
  var _iterator__ex2g4s = list.iterator_jk1svi_k$();
  $l$loop: while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    if (item == null)
      continue $l$loop;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(properties, 10));
    var _iterator__ex2g4s_0 = properties.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var item_0 = _iterator__ex2g4s_0.next_20eer_k$();
      var typedProp = isInterface(item_0, SerializableProperty()) ? item_0 : THROW_CCE();
      var fieldValue = typedProp.get_g4cbzo_k$(item);
      var tmp = CsvRenderer_instance;
      var tmp1_elvis_lhs = fieldValue == null ? null : toString(fieldValue);
      var tmp$ret$4 = escapeCsvField(tmp, tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
      destination.add_utx5q5_k$(tmp$ret$4);
    }
    var row = destination;
    // Inline function 'kotlin.text.appendLine' call
    var value_0 = joinToString(row, ',');
    // Inline function 'kotlin.text.appendLine' call
    sb.append_22ad7x_k$(value_0).append_58al37_k$(_Char___init__impl__6a9atx(10));
  }
  return sb.toString();
}
function fromCsv($this, csv, properties, elementSerializer) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = lines(csv);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(element)) {
      destination.add_utx5q5_k$(element);
    }
  }
  var lines_0 = destination;
  if (lines_0.isEmpty_y1axqb_k$())
    return emptyList();
  var header = parseCsvLine($this, lines_0.get_c1px32_k$(0));
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(header, 10));
  var index = 0;
  var _iterator__ex2g4s_0 = header.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s_0.next_20eer_k$();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var tmp$ret$6 = to(item, index_0);
    destination_0.add_utx5q5_k$(tmp$ret$6);
  }
  var columnMap = toMap(destination_0);
  // Inline function 'kotlin.collections.map' call
  var this_0 = drop(lines_0, 1);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s_1 = this_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
    var item_0 = _iterator__ex2g4s_1.next_20eer_k$();
    var fields = parseCsvLine(CsvRenderer_instance, item_0);
    var instance = createDefaultInstance(CsvRenderer_instance, elementSerializer);
    var _iterator__ex2g4s_2 = properties.iterator_jk1svi_k$();
    $l$loop_0: while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
      var prop = _iterator__ex2g4s_2.next_20eer_k$();
      var tmp0_elvis_lhs = columnMap.get_wei43m_k$(prop.get_name_woqyms_k$());
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var colIndex = tmp;
      if (colIndex >= fields.get_size_woubt6_k$())
        continue $l$loop_0;
      var fieldValue = fields.get_c1px32_k$(colIndex);
      var typedProp = isInterface(prop, SerializableProperty()) ? prop : THROW_CCE();
      var parsedValue = parseFieldValue(CsvRenderer_instance, fieldValue, prop);
      if (!(parsedValue == null) || prop.get_serializer_u29zhh_k$().get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$()) {
        instance = typedProp.setCopy_8a6bik_k$(instance, parsedValue);
      }
    }
    var tmp$ret$9 = instance;
    destination_1.add_utx5q5_k$(tmp$ret$9);
  }
  return destination_1;
}
function escapeCsvField($this, value) {
  var tmp;
  if (contains(value, _Char___init__impl__6a9atx(44)) || contains(value, _Char___init__impl__6a9atx(34)) || contains(value, _Char___init__impl__6a9atx(10))) {
    tmp = '"' + replace(value, '"', '""') + '"';
  } else {
    tmp = value;
  }
  return tmp;
}
function parseCsvLine($this, line) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var fields = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var current = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  var inQuotes = false;
  var i = 0;
  while (i < line.length) {
    var c = charCodeAt(line, i);
    if (c === _Char___init__impl__6a9atx(34) && !inQuotes) {
      inQuotes = true;
    } else if (c === _Char___init__impl__6a9atx(34) && inQuotes) {
      if ((i + 1 | 0) < line.length && charCodeAt(line, i + 1 | 0) === _Char___init__impl__6a9atx(34)) {
        current.append_58al37_k$(_Char___init__impl__6a9atx(34));
        i = i + 1 | 0;
      } else {
        inQuotes = false;
      }
    } else if (c === _Char___init__impl__6a9atx(44) && !inQuotes) {
      fields.add_utx5q5_k$(current.toString());
      current = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
    } else
      current.append_58al37_k$(c);
    i = i + 1 | 0;
  }
  fields.add_utx5q5_k$(current.toString());
  return fields;
}
function createDefaultInstance($this, serializer) {
  var tmp = default_0(serializer);
  return !(tmp == null) ? tmp : THROW_CCE();
}
function parseFieldValue($this, value, prop) {
  if (isBlank(value) && prop.get_serializer_u29zhh_k$().get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$())
    return null;
  var typeName = prop.get_serializer_u29zhh_k$().get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
  var tmp;
  switch (typeName) {
    case 'kotlin.String':
      tmp = value;
      break;
    case 'kotlin.Int':
      tmp = toIntOrNull(value);
      break;
    case 'kotlin.Long':
      tmp = toLongOrNull(value);
      break;
    case 'kotlin.Double':
      tmp = toDoubleOrNull(value);
      break;
    case 'kotlin.Float':
      // Inline function 'kotlin.text.toFloatOrNull' call

      // Inline function 'kotlin.js.unsafeCast' call

      // Inline function 'kotlin.js.asDynamic' call

      tmp = toDoubleOrNull(value);
      break;
    case 'kotlin.Boolean':
      var tmp_0 = listOf(['true', '1', 'yes']);
      // Inline function 'kotlin.text.lowercase' call

      // Inline function 'kotlin.js.asDynamic' call

      var tmp$ret$3 = value.toLowerCase();
      tmp = tmp_0.contains_aljjnj_k$(tmp$ret$3);
      break;
    case 'kotlin.Short':
      tmp = toShortOrNull(value);
      break;
    case 'kotlin.Byte':
      tmp = toByteOrNull(value);
      break;
    default:
      tmp = value;
      break;
  }
  return tmp;
}
function CsvRenderer$form$lambda(_this__u8e3s4) {
  text(_this__u8e3s4, 'Not a valid list');
  return Unit_instance;
}
function CsvRenderer$form$lambda_0(_this__u8e3s4) {
  text(_this__u8e3s4, 'Not a data class');
  return Unit_instance;
}
function TextView$_get_shown_$ref_kipsub(p0) {
  return constructCallableReference(() => p0.get_shown_iyiju0_k$(), 0, 0, 162, VOID, [p0]);
}
function TextView$_set_shown_$ref_l7jsq9(p0) {
  return constructCallableReference((p0_0) => {
    p0.set_shown_mavbz5_k$(p0_0);
    return Unit_instance;
  }, 1, 0, 163, VOID, [p0]);
}
function CsvRenderer$view$lambda(_this__u8e3s4) {
  text(_this__u8e3s4, 'Not a valid list');
  return Unit_instance;
}
function CsvRenderer$view$lambda_0(_this__u8e3s4) {
  text(_this__u8e3s4, 'Not a data class');
  return Unit_instance;
}
function CsvRenderer$toCsv$lambda(it) {
  return escapeCsvField(CsvRenderer_instance, it.get_name_woqyms_k$());
}
var CsvRendererClass;
function CsvRenderer() {
  if (CsvRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'CSV';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_x323j5_k$(context, module_0) {
        if (!equals(context.serializer_1.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), LIST_getInstance()))
          return -1.0;
        var tmp0_elvis_lhs = listElement(context.serializer_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return -1.0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var elementSerializer = tmp;
        if (!equals(elementSerializer.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), CLASS_getInstance()))
          return -1.0;
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_0 = get_serializableProperties(elementSerializer);
        var tmp_0;
        if (this_0 == null) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.collections.isEmpty' call
          tmp_0 = this_0.length === 0;
        }
        if (tmp_0)
          return -1.0;
        return 0.2;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_x323j5_k$(context, module_0);
      }
      form_pqm97q_k$(context, value, module_0) {
        var tmp = listElement(context.serializer_1);
        var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return CsvRenderer$form$lambda;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var elementSerializer = tmp_0;
        var tmp1_safe_receiver = get_serializableProperties(elementSerializer);
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toList(tmp1_safe_receiver);
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          return CsvRenderer$form$lambda_0;
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var properties = tmp_1;
        return (_this__u8e3s4) => {
          var errorMessage = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
          var this_0 = themed(element, CodeBlockSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextArea())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_0.willAddChild_hz2iwc_k$(element_0);
          var tmp = (list) => toCsv(CsvRenderer_instance, list, properties);
          element_0.bind_gesskf_k$(element_0.content_1, value.lens_u4wb4z_k$(tmp, (original, csv) => {
            var tmp;
            try {
              errorMessage.set_value_v1vabv_k$(null);
              tmp = fromCsv(CsvRenderer_instance, csv, properties, elementSerializer);
            } catch ($p) {
              var tmp_0;
              if ($p instanceof Exception()) {
                var e = $p;
                errorMessage.set_value_v1vabv_k$('CSV parse error: ' + e.message);
                tmp_0 = original;
              } else {
                throw $p;
              }
              tmp = tmp_0;
            }
            return tmp;
          }));
          element_0.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = new (TextView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          element.willAddChild_hz2iwc_k$(element_1);
          var tmp_0 = KMutableProperty0();
          var tmp_1 = TextView$_get_shown_$ref_kipsub(element_1);
          var tmp_2 = getPropertyCallableRef('shown', 0, tmp_0, tmp_1, TextView$_set_shown_$ref_l7jsq9(element_1));
          element_1.invoke_bnq13k_k$(tmp_2, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$(errorMessage) == null));
          var tmp_3 = KMutableProperty0();
          var tmp_4 = TextView$_get_content_$ref_4pzcwl(element_1);
          var tmp_5 = getPropertyCallableRef('content', 0, tmp_3, tmp_4, TextView$_set_content_$ref_pketfb(element_1));
          element_1.invoke_bnq13k_k$(tmp_5, ($this$invoke) => {
            var tmp0_elvis_lhs = $this$invoke.invoke_r7m7el_k$(errorMessage);
            return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
          });
          element_1.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_1);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_pqm97q_k$(context, value, module_0);
      }
      view_4nprpb_k$(context, value, module_0) {
        var tmp = listElement(context.serializer_1);
        var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, KSerializer()) : false) ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return CsvRenderer$view$lambda;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var elementSerializer = tmp_0;
        var tmp1_safe_receiver = get_serializableProperties(elementSerializer);
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toList(tmp1_safe_receiver);
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          return CsvRenderer$view$lambda_0;
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var properties = tmp_1;
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          var this_0 = themed(_this__u8e3s4, CodeBlockSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_wraps_9wisy1_k$(true);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => toCsv(CsvRenderer_instance, $this$invoke.invoke_r7m7el_k$(value), properties));
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_4nprpb_k$(context, value, module_0);
      }
      cellView_r7nadb_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => '' + $this$invoke.invoke_r7m7el_k$(value).get_size_woubt6_k$() + ' rows');
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_r7nadb_k$(context, value, module_0);
      }
      columnWidth_k7iu8b_k$(context, module_0) {
        return 15.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_k7iu8b_k$(context, module_0);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'CsvRenderer', VOID, VOID, [Renderer()]);
    CsvRendererClass = $;
  }
  return CsvRendererClass;
}
var CsvRenderer_instance;
function CsvRenderer_getInstance() {
  return CsvRenderer_instance;
}
//region block: init
CsvRenderer_instance = new (CsvRenderer())();
//endregion
//region block: exports
export {
  registerCsv as registerCsv2f0uur2hqp2nx,
  TextView$_get_shown_$ref_kipsub as TextView$_get_shown_$ref_kipsub2u3yvjqlogkp3,
  TextView$_set_shown_$ref_l7jsq9 as TextView$_set_shown_$ref_l7jsq921p8dnwznnah1,
};
//endregion

//# sourceMappingURL=CsvRenderer.mjs.map
